import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';

const {
GET_DASHBOARD_DOCUMENTATION_FAILURE,
GET_DASHBOARD_DOCUMENTATION_LOADER,
GET_DASHBOARD_DOCUMENTATION_SUCCESS,
GET_DASHBOARD_DOCUMENTATION_REQUEST
} = DashboardConstants;

function* dashboardDocumentationOverview(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DASHBOARD_DOCUMENTATION_LOADER });
    const response = yield call(dashboardServices.getDashboardDocumentationOverView, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_DOCUMENTATION_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_DOCUMENTATION_FAILURE, payload: error });
  }
}

function* dashboardDocumentationOverviewSaga() {
  yield takeEvery(GET_DASHBOARD_DOCUMENTATION_REQUEST, dashboardDocumentationOverview);
}

export default dashboardDocumentationOverviewSaga;
